import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-zero/react';
import { Link } from 'react-router-dom';

import {
  vEmail,
  vMinLength,
  vTrue,
  vOneOf,
  vIncludeUppercase,
  vIncludeLowercase,
  vIncludeNumber,
} from '@tokenyico/design-system';
import {
  DsForm,
  DsInputString,
  DsButton,
  DsInputCheckbox,
} from '@tokenyico/design-system/dist/reactJS';

import { AuthenticationService } from 'services';
import { formActions } from 'app/state/actions';

const mapToProps = (state) => state;

const SignUpAuthView = ({ history, setError }) => {
  const { t } = useTranslation();

  const [email, setEmail] = useState(null);
  const [terms, setTerms] = useState(null);
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function onSubmit() {
    try {
      setIsSubmitting(true);
      await AuthenticationService.signUp({ username: email, password });
      history.push('/auth/confirm-signup', { email });
      setIsSubmitting(false);
    } catch (error) {
      if (
        error.code === 'InvalidParameterException' &&
        error.message.includes('password') &&
        error.message.includes('length')
      ) {
        setError(t('validation.passwordInvalid'));
      } else if (error.code === 'InvalidPasswordException' && error.message.includes('uppercase')) {
        setError(t('validation.passwordInvalid'));
      } else if (error.code === 'InvalidPasswordException' && error.message.includes('lowercase')) {
        setError(t('validation.passwordInvalid'));
      } else {
        setError(error);
      }
      setIsSubmitting(false);
    }
  }

  return (
    <div className="card auth">
      <h1 className="auth__title">{t('shared.createAccount')}</h1>
      <DsForm onSubmit={onSubmit} id="sign-up">
        <DsInputString
          label={t('shared.email')}
          isFloatLabel={false}
          name="email"
          type="email"
          value={email}
          onDsInput={({ detail }) =>
            setEmail(typeof detail === 'string' ? detail.toLocaleLowerCase() : detail)
          }
          validate={vEmail}
          className="_m:top(2)"
        />
        <DsInputString
          label={t('shared.password')}
          isFloatLabel={false}
          name="password"
          type="password"
          value={password}
          onDsInput={({ detail }) => setPassword(detail)}
          validate={(v) =>
            vMinLength(8)(v) || vIncludeUppercase(v) || vIncludeLowercase(v) || vIncludeNumber(v)
          }
          className="_m:top(2)"
        />
        <DsInputString
          label={t('shared.confirmPassword')}
          isFloatLabel={false}
          name="confirmPassword"
          type="password"
          value={confirmPassword}
          onDsInput={({ detail }) => setConfirmPassword(detail)}
          validate={(v) =>
            vOneOf([password])(v) ? t('validation.passwordConfirmMatch') : undefined
          }
          className="_m:top(2)"
        />

        <div className="auth__terms">
          <DsInputCheckbox
            name="termsRequired"
            checkedValue={true}
            label={t('shared.signUpTermsLabel')}
            value={terms}
            onDsInput={({ detail }) => setTerms(detail)}
            validate={(v) => (vTrue(v) ? t('validation.required') : undefined)}
          >
            <div slot="helperText" className="_p:left(3) _p:top(1)">
              <span dangerouslySetInnerHTML={{ __html: t('shared.signUpTerms') }} />
            </div>
          </DsInputCheckbox>
        </div>
        <br />
        <div className="auth__button-primary">
          <DsButton
            version="primary"
            label={t('shared.signUp')}
            type="submit"
            isLoading={isSubmitting}
            icon="arrow-right"
            iconHeight={11}
          />
        </div>
      </DsForm>
      <div className="auth__footer">
        <Link to="/">
          <DsButton label={t('shared.iAlreadyHaveAnAccount')} mode="text" />
        </Link>
      </div>
    </div>
  );
};

export default connect(mapToProps, formActions)(SignUpAuthView);
